import './DynamicProfile.scss';
import { Extent, Map, MapView, SpatialReference } from 'cd-eft/utils/esriTypes';
import React, { useEffect, useRef, useState } from 'react';
import { DynamicProfileStoreBase } from 'cd-eft/models/Stores/DynamicProfile/DynamicProfileStoreBase';
import stores from 'cd-eft/models/Stores';
import { mdiCircleMedium } from '@mdi/js';
import Icon from '@mdi/react';
import { Loader } from '../LoadingSpinner/LoadingSpinner';
import * as profileSymbolsAndLabels from 'cd-eft/models/Stores/DynamicProfile/profileSymbolsAndLabels';

const libraryStore = stores.AppStore.projectsLibraryStore;

interface IDynamicSingleCSProfileProps {
  profileStore: DynamicProfileStoreBase | undefined;
  editable: boolean;
}

const DynamicSingleCSProfile = (props: IDynamicSingleCSProfileProps) => {
  const [waitingInit, setWaitingInit] = useState(true)
  const profileMapViewRef = useRef<MapView>();
  if (!profileMapViewRef.current) {
    const spatialReference = new SpatialReference({ wkid: 102965 });
    const extent = new Extent({ xmin: 0, ymin: 0, xmax: 100, ymax: 110, spatialReference });

    profileMapViewRef.current = new MapView({ map: new Map({ layers: [] }), extent, spatialReference });
  }

  useEffect(() => {
    if (profileMapViewRef.current) {

      const sr: SpatialReference = libraryStore.projectSpatialReference!;
      props.profileStore?.initialize(profileMapViewRef.current, sr, props.editable, 'singleCrossSection');
      setWaitingInit(false);

      profileMapViewRef.current.container = document.getElementById('single-CS-Profile') as HTMLDivElement;
      if (props.profileStore) props.profileStore.startLengthyProcess = (state: boolean) => setWaitingInit(state);
    }
  }, [props.editable, props.profileStore]);

  return (
    <div>
      <div id={'profile-and-peripherals-container'}>
        <div id={'single-CS-Profile'} style={{ position: "relative" }}>
          <div className="mt-5" hidden={!waitingInit}>
            <Loader message={'Loading profiles ...'} />
          </div>
        </div> 
        <div>
          <div>
              <div title='Zoom In' className='esri-icon-zoom-in-fixed esri-widget--button esri-widget esri-interactive home profile-btn' onClick={() => { if (profileMapViewRef.current) profileMapViewRef.current.extent = profileMapViewRef.current.extent.expand(0.75) }}></div>
              <div title='Zoom Out' className='esri-icon-zoom-out-fixed esri-widget--button esri-widget esri-interactive home profile-btn' onClick={() => { if (profileMapViewRef.current) profileMapViewRef.current.extent = profileMapViewRef.current.extent.expand(1.25) }}></div>
          </div>
          <div title='Zoom to Extent' className='esri-icon-applications esri-widget--button esri-widget esri-interactive home profile-btn' onClick={() => { if (profileMapViewRef.current && props.profileStore?.maxExtent) profileMapViewRef.current.extent = props.profileStore?.maxExtent }}></div>
        </div>
      </div>
      <div className='profile-legend'>
        <div className='legend-row'>
          <Icon path={mdiCircleMedium} size={1}  style={{ color: profileSymbolsAndLabels.netsLegendOrange }} />
        <div className='legend-text'>Design Surface</div>
        </div>
        <div className='legend-row'>
          <Icon path={mdiCircleMedium} size={1} style={{ color: profileSymbolsAndLabels.netsLegendPink }} />
        <div className='legend-text'>Original Surface</div>
        </div>
      </div>
    </div>
  );
};

export { DynamicSingleCSProfile };
